<template>

    <div class="ma">

        <div class="ma__header">

            <div class="ma__header__row">
                <div class="ma__header__bloc">
                    <button class="ma__header__back" @click="back">
                        <img src="/img/newsletters-v2/chevron-left-blue.svg" class="ma__header__back__ico">
                        <p class="text-lSemibold color__aquamarine">{{ $t('global_back') }}</p>
                    </button>
                </div>
                <div class="ma__header__bloc ma__header__bloc__middle">
                    <h1 :class="isDesktop ? 'title-baseSemibold' : 'text-lSemibold'">{{ $t('reverse_action') }}</h1>
                </div>
                <div class="ma__header__bloc"></div>
            </div>

            <div class="ma__header__row ma__header__row__action" v-show="isDesktop">

                <header-action :blocked="blocked.length"
                               :kept="kept.length"
                               :category="category"
                               @updateCategory="updateCategory"></header-action>
            </div>

        </div>

        <header-action v-show="!isDesktop"
                       :blocked="blocked.length"
                       :kept="kept.length"
                       :category="category"
                       @updateCategory="updateCategory"></header-action>


        <div v-if="showLoader" class="ma__loading">
                    <lottie-loader></lottie-loader>
        </div>
        <div class="ma__content" v-else>
            <div class="ma__tr" v-show="isDesktop">
                <div class="ma__tr__selected">
                    <div v-show="showCtaAction" class="ma__tr__selected__show">
                        <p class="text-lMedium color__moon">
                            {{ $tc('cleaning_list_selected', countSelected, {nbSelected: countSelected}) }}</p>
                        <button class="ma__tr__selected__cta" @click="openMyActionsModal">
                            <img src="/img/newsletters-v2/rewind-blue.svg" class="ma__tr__selected__cta__ico img__lang">
                            <p class="text-lSemibold">
                                {{ isBlocked ? $t('cleaning_stop_auto-delete') : $t('cleaning_stop_keep') }}</p>
                        </button>
                    </div>

                </div>
                <div class="ma__tr__row">
                    <div class="ma__tr__left pointer" @click="toggleAll">
                        <img
                            :src="isAllSelected ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'">
                    </div>
                    <div class="ma__tr__bloc">
                        <p class="text-lSemibold color__moon">{{ $t('cleaning_sender') }}</p>
                    </div>
                    <div class="ma__tr__bloc">
                        <p class="text-lSemibold color__moon">{{ $t('cleaning_select_inbox') }}</p>
                    </div>
                    <div class="ma__tr__bloc">
                        <p class="text-lSemibold color__moon">{{ $t('cleaning_status') }}</p>
                    </div>
                </div>
            </div>

            <div class="ma__scroll">

                <div class="ma__item pointer" v-for="(item, index) in actionList" @click="toggleItem(index)">
                    <div class="ma__item__row">
                        <div class="ma__item__row__left">
                            <img
                                :src="item.checked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'">
                        </div>
                        <div class="ma__item__row__middle ellipsis-text">
                            <p class="ellipsis-text"
                               :class="isDesktop ? 'text-xlSemibold-2' : 'text-lSemibold'"
                            >{{ item.name }}</p>
                            <p class="color__moon ellipsis-text"
                               :class="isDesktop ? 'text-lMedium' : 'text-baseMedium'">{{ item.sender }}</p>
                        </div>
                        <div v-show="isDesktop" class="ma__item__row__email ellipsis-text">
                            <p class="text-lSemibold color__moon ellipsis-text">{{ item.email }}</p>
                        </div>
                        <div class="ma__item__row__right">
                            <p :class="[
                           isDesktop ? 'text-baseSemibold-2' : 'text-sMedium',
                           isBlocked ? 'color__raspberry' : 'color__lime'
                           ]"
                            >{{ $t(isBlocked ? 'cleaning_cards_autodelete' : 'cleaning_cards_keep') }}</p>
                            <p :class="isDesktop ? 'text-lSemibold color__charcoal' : 'text-sRegular color__moon'"
                            >{{ $tc('done_date', 0, {date: dateFormat(item.date)}) }}</p>
                        </div>
                    </div>

                    <div v-show="!isDesktop">
                        <div class="ma__item__email mt__8">
                            <img src="/img/newsletters-v2/inbox-in-grey.svg" class="ma__item__email__ico">
                            <p class="text-sRegular color__moon">{{ item.email }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ma__empty" v-show="actionList.length === 0">

                <img src="/img/newsletters-v2/illustration-empty.svg" class="img__96">

                <p class="text-xlSemibold-2 text-lSemibold mt__32"
                   :class="isDesktop ? 'text-xlSemibold-2' : 'text-lSemibold'">
                    {{ isBlocked ? $t('my_actions_autodelete_empty_title') : $t('my_actions_keep_empty_title') }}
                </p>

                <p class="  color__moon mt__2"
                   :class="isDesktop ? 'text-lRegular' : 'text-baseRegular-2'">
                    {{
                        isBlocked ? $t('my_actions_autodelete_empty_description') : $t('my_actions_keep_empty_description')
                    }}
                </p>

                <button class="ma__empty__cta text-lSemibold" @click="back">{{ $t('cleaning_sort_newsletters') }}
                </button>

            </div>

            <button class="ma__cta" v-show="showCtaAction && !isDesktop" @click="openMyActionsModal">
                <img src="/img/newsletters-v2/rewind-white.svg" class="ma__cta__ico">
                <p class="text-lSemibold color__white">
                    {{ isBlocked ? $t('cleaning_stop_delete') : $t('cleaning_stop_keep') }}</p>
            </button>

        </div>

        <modal-my-actions ref="MMA"
                          :category="category"
                          :arrayItems="actionListSelected"
                          @close="modalClosed"
        ></modal-my-actions>

    </div>

</template>

<script>
import Vuex from 'vuex'

import moment from 'moment'

import Api from '@/api'

import ENUM from '@/assets/ENUM'

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import Checkbox from '@/components/inputs/Checkbox'
import HeaderAction from '@/components/newsletters-v2/HeaderAction'
import LottieLoader from '@/components/lottie/LottieLoader'
import ModalMyActions from '@/components/modal/ModalMyActions'

export default {

    name: 'my-actions',

    components: {
        Checkbox,
        HeaderAction,
        LottieLoader,
        ModalMyActions
    },

    watch: {
        isActionsBatchNotEmpty(notEmpty) {
            if(!notEmpty) {
                this.requestData()
            }
        }
    },

    computed: {


        ...Vuex.mapGetters([
            'actionsBatchTempDelete',
            'actionsBatchTempKeep',
            'actionsBatchTempUnsubscribe'
        ]),

        ENUM() {
            return ENUM
        },

        actionList() {
            return this.category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE
                ? this.blocked
                : this.kept
        },

        actionListSelected() {
            return this.actionList.filter(item => item.checked)
        },

        isAllSelected() {
            return this.actionList.length && this.countSelected === this.actionList.length
        },

        countSelected() {
            return this.actionListSelected.length
        },

        showCtaAction() {
            return this.countSelected > 0
        },

        isBlocked() {
            return this.category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE
        },

        isActionsBatchNotEmpty() {
            return this.actionsBatchTempDelete.length > 0
                || this.actionsBatchTempKeep.length > 0
                || this.actionsBatchTempUnsubscribe.length > 0
        },

        showLoader() {
            return this.loading || this.isActionsBatchNotEmpty
        }

    },
    data() {
        return {
            blocked: [],
            kept: [],
            category: '',
            loading: false
        }
    },

    mounted() {

        UserFlow.setPage(this, 'my-actions')

        moment.locale(I18n.get(this))

        this.requestData()

        this.updateCategory(ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE)
    },

    methods: {

        requestData() {

            this.loading = true
            const promiseKept = Api.newsletters.kept()
                .then(dataKept => {
                    this.kept = dataKept.subscriptions
                        .map(item => {
                            return {...item, checked: false}
                        })
                })

            const promiseBlocked = Api.newsletters.blocked()
                .then(dataBlocked => {
                    this.blocked = dataBlocked.subscriptions
                        .map(item => {
                            return {...item, checked: false}
                        })
                })

            Promise.all([promiseKept, promiseBlocked])
                .catch(() => {
                    this.error = true
                })
                .finally(() => {
                    this.loading = false
                })

        },

        modalClosed(refreshData) {
            if (refreshData) {
                this.requestData()
            }
        },

        dateFormat(str) {

            return moment(str).format('L')

        },

        toggleCard(item) {

            if (this.edit) {
                item.selected = !item.selected
            }
        },

        openMyActionsModal() {

            Tag.clickAmplitude(this, 'edit')

            this.$refs.MMA.open()

        },

        back() {

            this.$router.push({path: '/newsletters'})

        },

        updateCategory(category) {
            this.category = category
        },

        toggleItem(index) {
            this.actionList[index].checked = !this.actionList[index].checked
            this.$forceUpdate()
        },

        toggleAll() {
            this.isAllSelected
                ? this.actionList.map(item => item.checked = false)
                : this.actionList.map(item => item.checked = true)
        }

    }
}

</script>

<style lang="scss" scoped>

.ma {
    background-color: $timberwolf;
    position: relative;
    align-items: center;

    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
    }

    &__header {
        width: 100%;

        &__row {
            display: flex;
            flex-direction: row;
            padding: 16px;
            align-items: center;
            border-bottom: 1px solid $divider;

            @media screen and (min-width: $above-tablet-length) {
                padding: 22px 32px;
            }

            &__action {
                @media screen and (min-width: $above-tablet-length) {
                    padding: 12px;
                    display: flex;
                    justify-content: center;
                    white-space: nowrap;
                }
            }


        }

        &__bloc {
            display: flex;
            flex-direction: row;
            flex: 1;

            &__middle {
                justify-content: center;
            }
        }

        &__bloc-right {
            justify-content: flex-end;
        }

        &__cta {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 8px 12px;
            background-color: $white;
            border-radius: 72px;
        }

        &__back {
            background-color: $timberwolf;
            display: flex;
            flex-direction: row;
            align-items: center;
            @media screen and (min-width: $above-tablet-length) {
                background-color: $white;
            }

            &__ico {
                width: 20px;
                object-fit: contain;
                margin: 0 4px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 4px;
                    transform: rotate(180deg);
                }
            }
        }

        &__mail {
            padding: 8px 12px 8px 16px;
            background-color: $white;
            border-radius: 72px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }

    &__loading {
        flex: 1;
        display: flex;
        background-color: $white;
        justify-content: center;
        align-items: center;
    }

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
    }

    &__tr {
        width: 100%;
        background-color: $timberwolf;

        &__selected {
            height: 65px;
            padding: 25px 33px 0;
            display: flex;
            flex-direction: row;

            &__show {
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            &__cta {
                padding: 8px;
                display: flex;
                flex-direction: row;
                align-items: center;
                background-color: inherit;

                &__ico {
                    width: 24px;
                    object-fit: contain;
                    margin: 0 8px 0 0;

                    &:lang(ar-sa) {
                        margin: 0 0 0 8px;
                    }
                }
            }
        }

        &__row {
            display: flex;
            flex-direction: row;
        }

        &__left {
            padding: 16px 32px;
        }

        &__bloc {
            padding: 16px;
            flex: 1;
            text-align: start;
        }
    }

    &__scroll {
        width: 100%;
        overflow-y: scroll;
        scroll-behavior: smooth;
    }

    &__item {
        padding: 16px;
        display: flex;
        flex-direction: column;

        @media screen and (min-width: $above-tablet-length) {
            padding: 0;
        }

        &__row {
            display: flex;
            flex-direction: row;

            &__left {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 16px 0 0;

                &:lang(ar-sa) {
                    padding: 0 0 0 16px;
                }

                @media screen and (min-width: $above-tablet-length) {
                    padding: 16px 32px;
                    &:lang(ar-sa) { //fix order
                        padding: 16px 32px;
                    }
                }


            }

            &__middle {
                display: flex;
                flex-direction: column;
                flex: 1;
                text-align: start;

                @media screen and (min-width: $above-tablet-length) {
                    padding: 16px;
                    flex: 1;
                }
            }

            &__email {
                @media screen and (min-width: $above-tablet-length) {
                    padding: 16px;
                    flex: 1;
                    display: flex;
                    align-items: center;
                }
            }

            &__right {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                text-align: right;
                @media screen and (min-width: $above-tablet-length) {
                    padding: 16px;
                    flex: 1;
                    text-align: start;
                    align-items: flex-start;
                }
            }
        }

        &__email {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 2px 6px;
            border-radius: 20px;
            border: solid 1px #e7e7e8;
            width: fit-content;
            margin-left: 36px;

            &__ico {
                width: 16px;
                object-fit: contain;
                margin: 0 4px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 4px;
                }
            }
        }
    }

    &__cta {
        position: fixed;
        bottom: 68px;
        display: flex;
        justify-content: center;
        padding: 8px 16px;
        flex-direction: row;
        align-items: center;
        background-color: $aquamarine;
        border-radius: 72px;

        &__ico {
            width: 24px;
            object-fit: contain;
            margin: 0 8px 0 0;

            &:lang(ar-sa) {
                margin: 0 0 0 8px;
            }
        }
    }


    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        padding: 16px;

        &__cta {
            margin-top: 24px;
            padding: 16px 40px;
            border-radius: 72px;
            background-color: $aquamarine;
            color: $white;
        }
    }
}

</style>

